import { render, staticRenderFns } from "./HomePageLayout.vue?vue&type=template&id=4c4959a6&scoped=true"
import script from "./HomePageLayout.vue?vue&type=script&lang=js"
export * from "./HomePageLayout.vue?vue&type=script&lang=js"
import style0 from "./HomePageLayout.vue?vue&type=style&index=0&id=4c4959a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4959a6",
  null
  
)

export default component.exports